import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthenticatedRoute } from './components/AuthenticatedRoute';
import { Login } from './components/Login';
import { GatewayDebugger } from './components/GatewayDebugger';

function App() {
  // Amplify is configured in main.tsx from /config.json. Avoid reconfiguring here.

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <AuthenticatedRoute>
              <GatewayDebugger />
            </AuthenticatedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;